// lib/auth-api.ts
// Типизированный клиент для всех auth эндпоинтов Salaria

//const API_BASE = process.env.NEXT_PUBLIC_API_URL ?? "https://api.salaria.top";

// must have!!!

const API_BASE = process.env.NEXT_PUBLIC_API_URL 
  ? `${process.env.NEXT_PUBLIC_API_URL}` 
  : "/api";
//const API_BASE = process.env.NEXT_PUBLIC_API_URL ?? "https://api-dev.salaria.top";


export class AuthApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

async function apiFetch<T>(path: string, options: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers ?? {}),
    },
    credentials: "include",
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new AuthApiError(
      res.status,
      data?.message ?? "Неизвестная ошибка"
    );
  }

  return data as T;
}

// ── Types ──────────────────────────────────────────────

export interface AuthUser {
  id: string;
  email: string;
  role: string;
  energyBalance: number;
}

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
  rememberMe: boolean;
}

export interface AuthResponse {
  user: AuthUser;
  accessToken: string;
  refreshToken: string;
  rememberMe: boolean;
}

// ── Register ───────────────────────────────────────────

export async function apiRegister(payload: {
  email: string;
  password: string;
  fingerprintHash?: string;
}): Promise<AuthResponse> {
  const { fingerprintHash, ...body } = payload;
  return apiFetch("/auth/register", {
    method: "POST",
    headers: { ...(fingerprintHash ? { 'x-fingerprint': fingerprintHash } : {}) },
    body: JSON.stringify(body),
  });
}

// ── Login ──────────────────────────────────────────────

export async function apiLogin(payload: {
  email: string;
  password: string;
  rememberMe?: boolean;
  fingerprintHash?: string;
}): Promise<AuthResponse> {
  return apiFetch("/auth/login", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

// ── Verify OTP ─────────────────────────────────────────
// TODO: реализовать на бэке POST /auth/verify-otp
export async function apiVerifyOtp(payload: {
  email: string;
  code: string;
}): Promise<AuthResponse> {
  return apiFetch("/auth/verify-otp", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

// ── Logout ─────────────────────────────────────────────

export async function apiLogout(refreshToken: string, accessToken: string): Promise<void> {
  return apiFetch("/auth/logout", {
    method: "POST",
    headers: { Authorization: `Bearer ${accessToken}` },
    body: JSON.stringify({ refreshToken }),
  });
}

// ── Refresh ────────────────────────────────────────────

//export async function apiRefresh(refreshToken: string): Promise<{ accessToken: string }> {
//  return apiFetch("/auth/refresh", {
//    method: "POST",
//    body: JSON.stringify({ refreshToken }),
//  });
//}

// ── Get Me ─────────────────────────────────────────────

export async function apiGetMe(accessToken: string): Promise<AuthUser> {
  return apiFetch("/auth/me", {
    method: "GET",
    headers: { Authorization: `Bearer ${accessToken}` },
  });
}

// ---------  forgot password / reset password / change password — по необходимости ---------
export async function apiRequestPasswordReset(data: { email: string }) {
  const res = await fetch(`${API_BASE}/auth/forgot-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new AuthApiError(res.status, body.message ?? "Ошибка запроса");
  }
  return res.json();
}

export async function apiResetPassword(data: { token: string; password: string }) {
  const res = await fetch(`${API_BASE}/auth/reset-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new AuthApiError(res.status, body.message ?? "Ошибка запроса");
  }
  return res.json();
}

// ── Token storage helpers ──────────────────────────────
// ── Token storage — используй из lib/auth.ts ──────────────────
// saveTokens / getAccessToken / getRefreshToken / clearTokens
export { getAccessToken, clearTokens } from "./auth";
//export const tokenStorage = {
//  save(tokens: AuthTokens) {
//    // accessToken — только в памяти (sessionStorage)
    // refreshToken — localStorage только если rememberMe
//    sessionStorage.setItem("salaria_at", tokens.accessToken);
//    if (tokens.rememberMe) {
//      localStorage.setItem("salaria_rt", tokens.refreshToken);
//    } else {
//      sessionStorage.setItem("salaria_rt", tokens.refreshToken);
//    }
//  },

//  getAccess(): string | null {
//    return sessionStorage.getItem("salaria_at");
//  },

//  getRefresh(): string | null {
//    return localStorage.getItem("salaria_rt") ?? sessionStorage.getItem("salaria_rt");
//  },

//  clear() {
//    sessionStorage.removeItem("salaria_at");
//    sessionStorage.removeItem("salaria_rt");
//    localStorage.removeItem("salaria_rt");
//  },
//};